import React from "react";
import {graphql} from "gatsby";
import {Layout} from "../components/layout";
import {makeStyles} from "@material-ui/core/styles";
import {WorkshopPreview} from "../components/workshopPreview";
import { shortenText } from "../helpers/shortenText"

const useStyles = makeStyles((theme) => ({
    speaker: {
        marginBottom: theme.spacing(2),
    },
}));

export const query = graphql`
    query {
        pageText {
            page {
                workshops {
                    title
                    slug
                }
            }
        }
        allGoogleSheetWorkshopsRow {
            nodes {
                title
                subtitle
                text
                author
                id
                fields {
                    slug
                }
                childrenDropboxNode {
                    localFile {
                        childImageSharp {
                            fixed(width: 128, height: 128) {
                                src
                                srcSet
                            }
                        }
                    }
                }
            }
        }
    }
`;

const getSrcSet = (speaker) => {
    const cdn = speaker.childrenDropboxNode[0];
    if(!cdn) return null;
    return cdn.localFile.childImageSharp.fixed.src;
};

const Workshop = ({data}) => {
    const classes = useStyles();

    return (
        <Layout title={data.pageText.page.workshops.title} showTitle>
            {data.allGoogleSheetWorkshopsRow.nodes.map(e => <WorkshopPreview
                key={e.id}
                className={classes.speaker}

                title={e.title}
                subtitle={e.subtitle}
                image={getSrcSet(e)}
                name={e.author}
                text={shortenText(e.text)}
                slug={`${data.pageText.page.workshops.slug}/${e.fields.slug}`}
            />)}
        </Layout>
    );

};

export default Workshop